<template>
<div class="row mt-4">
  <div class="col-sm-8">
    <label for="input">Categoria de Archivo</label>
    <v-select
      ref="document_category"
      class="select"
      v-model="file_category"
      label="name"
      :options="file_categories"
      />
    <hr />
    <vue-dropzone
      ref="investorDropzone"
      @vdropzone-sending="appendDocumentParameters"
      @vdropzone-success="successDropzone"
      v-if="file_category"
      id="dropzone"
      :options="dropzoneOptions">
    </vue-dropzone>
  </div>
  <div class="col-sm-4">
    <!-- end: Begin Category -->
    <div
      v-for="category in file_categories"
      :key="category.id"
      class="investor-file-group">
      <h5> {{ category.name }} </h5>
      <div v-for="file in investor_files.filter((f) => f.investor_file_category_id == category.id)" v-bind:key="file.id">
        <div class="download-card alert alert-success">
          <a
            class="btn btn-xs btn-success"
            :href="file.url"
            target="_blank">
            <fai icon="arrow-down"/>
          </a>
          <div class="download-details">
            {{ file.name }}
            <small> {{ file.created_at }} </small>
          </div>
          <a
            class="label-danger label remove"
            @click="deleteDocument(file.id)">
            <fai icon="times"/>
          </a>
        </div>
      </div>
      <div v-if="!investor_files.filter((f) => f.investor_file_category_id == category.id).length">
        <div class="alert alert-warning" >
          No se han subido archivos en esta categoria
        </div>
      </div>
    </div>
    <!-- end: File Category -->
  </div>
</div>
</template>

<script>
import investorService from '@/services/investors'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import store from '@/store'

import apiConfig from '@/services/api-config'

export default {
  name: 'InvestorFiles',

  props: {
    file_categories: { type: Array, required: true },
    investor_files: { type: Array, required: true }
  },

  components: { vueDropzone: vue2Dropzone },

  data () {
    return {
      dropzoneOptions: {
        url: `${apiConfig.apiUrl}/investor/${this.$route.params.id}/document`,
        headers: {
          Authorization: store.getters.getToken
        }
      },
      file_category: null
    }
  },

  methods: {
    appendDocumentParameters (file, xhr, formData) {
      formData.append('investor_file_category_id', this.file_category.id)
    },

    successDropzone (file, response) {
      this.$refs.investorDropzone.removeAllFiles()
      this.investor_files.push(response)
    },

    deleteDocument (documentId) {
      let investorId = this.$route.params.id
      let component = this

      this.$swal({
        title: 'Deseas borrar el documento?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          investorService.deleteDocument(investorId, documentId).then(res => {
            if (!res.error) {
              let files = component.investor_files.filter(file => {
                return file.id != documentId
              })
              this.$swal('El documento ha sido eliminado', {
                icon: 'success'
              })
              this.$emit('update:investor_files', files)
            } else {
              this.$scal('Ha ocurrido un error', 'Favor de intentar nuevamente', {
                icon: 'error'
              })
            }
          })
        }
      })
    }
  }
}

</script>

<style scoped>
.download-card {
    display: flex;
    margin: 10px 0;
}

.remove{
  color: red;
}

.download-details {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/investors/InvestorFiles.vue